import React, { useMemo, useState } from "react";
import {
  Card,
  CardContent,
  List,
  ListItem,
  Divider,
  Button,
  CircularProgress,
  Box,
  Snackbar,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {
  acceptImprovement,
  addFoulWord,
  cancelImprovement,
  getFoulWords,
} from "../../../redux/slices/foulWordsSlice";

const ImprovedFoulList = () => {
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(false);
   const { improvedFoulWords: words, ImprovementLoading: loading } = useSelector(
     (state) => state.foulWordsDetails
    );
 
  const handleSaveImprovement = async () => {
    console.log('handleSaveImprovement: ');
    setIsSaving(true);
    setError("");

    try {
        const res = await dispatch(addFoulWord({foulWordList:words}));
      console.log('res: ', res);

      if (res.meta.requestStatus === "fulfilled") {
        dispatch(acceptImprovement());
        dispatch(getFoulWords())
      } else {
        throw new Error(res.payload || "Saving failed");
      }
    } catch (err) {
      setError(true);
    } finally {
      setIsSaving(false);
    }
  };

  const renderedWordList = useMemo(() => (
    <List dense>
      {words && words.length > 0 ? (
        words.map((word, index) => (
          <div key={index}>
            <ListItem
              sx={{
                background: "linear-gradient(145deg, #f9f7fc 0%, #ffffff 100%)",
                borderRadius: "8px",
                px: 2,
                py: 1.2,
                my: 1,
                fontSize: "1rem",
                fontWeight: 500,
                color: "#444",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              }}
            >
              {word}
            </ListItem>
            {index !== words.length - 1 && <Divider />}
          </div>
        ))
      ) : (
        <MDTypography variant="body2" color="textSecondary">
          No AI-suggested words available.
        </MDTypography>
      )}
    </List>
  ), [words]);

  return (
    <MDBox position="relative">
      <Card
        variant="outlined"
        sx={{
          background: "#fdfdfd",
          borderRadius: 3,
        }}
      >
        <CardContent>
          <MDTypography variant="h6" mb={2} sx={{ color: "#8e5bb8ff" }}>
            ✨ AI-Enhanced Suggestions
          </MDTypography>

          <div
            style={{
              height: "60vh",
              overflowY: "auto",
              overflowX: "hidden",
              paddingRight: 8,
              background: "radial-gradient(circle at top left, #f6f0ffff, #ffffff)",
              borderRadius: "8px",
              padding: "10px",
              position: "relative",
            }}
          >
            {loading ? (
              <MDBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 60,
                    height: 60,
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      border: "5px solid transparent",
                      borderTopColor: "#b388ff",
                      borderRightColor: "#8e5bb8",
                      animation: "spin 1s linear infinite",
                      boxShadow: "0 0 10px #d8c1ff",
                      "@keyframes spin": {
                        "0%": {
                          transform: "rotate(0deg)",
                        },
                        "100%": {
                          transform: "rotate(360deg)",
                        },
                      },
                    }}
                  />
                </Box>

                <MDTypography
                  variant="body2"
                  mt={2}
                  fontWeight="bold"
                  sx={{
                    position: "relative",
                    color: "#8e5bb8",
                    background: "linear-gradient(90deg, #9c72d9, #e0bbff, #9c72d9)",
                    backgroundSize: "200% auto",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    animation: "shine 2.5s linear infinite",
                    fontSize: "1rem",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                    "@keyframes shine": {
                      "0%": { backgroundPosition: "200% center" },
                      "100%": { backgroundPosition: "-200% center" },
                    },
                  }}
                >
                  Improving suggestions with AI...
                </MDTypography>

              </MDBox>
            ) : (
              renderedWordList
            )}
          </div>
        </CardContent>

        {!loading && (
          <MDBox
            display="flex"
            justifyContent="flex-end"
            gap={2}
            px={3}
            py={2}
            borderTop="1px solid #e6e0f8"
            bgcolor="#f9f6ff"
          >
            <Button
              variant="outlined"
              onClick={() => dispatch(cancelImprovement())}
              sx={{
                borderColor: "#9e7cf6",
                color: "#6a41d1",
                "&:hover": {
                  backgroundColor: "#efe6ff",
                  borderColor: "#6a41d1",
                },
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleSaveImprovement}
              disabled={isSaving}
              sx={{
                background: "linear-gradient(135deg, #7c4dff, #9575cd)",
                color: "#fff",
                transition: "background 0.3s ease",
                "&:hover": {
                  background: "linear-gradient(135deg, #6a41d1, #845ec2)",
                },
              }}
            >
              {isSaving ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Save"}
            </Button>

        {error && (
  <Box
    mt={2}
    px={2}
    py={1.5}
    borderRadius={1}
    bgcolor="#fdecea"
    color="#611a15"
    border="1px solid #f5c6cb"
    fontSize="14px"
    fontWeight="500"
  >
   Something Went Wrong
  </Box>
 )}

          </MDBox>
        )}
      </Card>
    </MDBox>
  );
};

export default ImprovedFoulList;
